import { render, staticRenderFns } from "./KharkovOblEnergo.vue?vue&type=template&id=378828aa&scoped=true&"
import script from "./KharkovOblEnergo.vue?vue&type=script&lang=js&"
export * from "./KharkovOblEnergo.vue?vue&type=script&lang=js&"
import style0 from "./KharkovOblEnergo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./KharkovOblEnergo.vue?vue&type=style&index=1&id=378828aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378828aa",
  null
  
)

export default component.exports